import apiService from '@/api/apiService';

export const assignRoleToManager = async (managerId, roles) => {
    const url = `/api/admin/assign-role/${managerId}`;

    const data = {
        roles: roles
    };

    return apiService.POST(url, data);
};
